const ActionDispatcher = {
    install (Vue, options) {
        Vue.prototype.$action = {
            dispatch(name, ...args) {
                return new Promise(( resolve, reject ) => {
                    if ( typeof this[name] !== 'undefined' ) {
                        resolve(this[ name ](...args));
                    }

                    reject();
                });
            },

            register(name, callback) {
                this[ name ] = callback;
            },
        };
    }
}

export default ActionDispatcher;